import { apiCall } from './gqlClient';

const GETAUTHORS_QUERY = `
  query getAuthors {
    getAuthors
    {
      id
			userId
			title
			description
			info
			image
      ...fragments
    }
  }`;

export const getAuthorsApiCall = async (fragments = null) => apiCall({ query: GETAUTHORS_QUERY, variables: {}, fragments });
